import React from 'react';
import { Wrench, Zap, Monitor, Car, MapPin } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <Wrench className="h-10 w-10 text-red-600" />,
      title: 'Expertise automobile',
      description: 'Une spécialisation dans le diagnostic et l\'électronique automobile.'
    },
    {
      icon: <Zap className="h-10 w-10 text-red-600" />,
      title: 'Recherche de panne complexe',
      description: 'Analyse des systèmes électriques et électroniques du véhicule.'
    },
    {
      icon: <Monitor className="h-10 w-10 text-red-600" />,
      title: 'Équipement professionnel',
      description: 'Lecture et écriture de calculateurs avec des outils adaptés aux interventions réalisées.'
    },
    {
      icon: <Car className="h-10 w-10 text-red-600" />,
      title: 'Des centaines d\'interventions',
      description: 'Une expérience construite au fil des années et des véhicules pris en charge.'
    },
    {
      icon: <MapPin className="h-10 w-10 text-red-600" />,
      title: 'Atelier à Creutzwald',
      description: 'Un professionnel local facilement accessible en Moselle.'
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-b from-slate-900 to-slate-950">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-white mb-4">
          Pourquoi choisir <span className="text-red-600">JC Performance-57</span> ?
        </h2>
        <p className="text-center text-gray-400 text-xl mb-16 max-w-3xl mx-auto">
          Un professionnel de confiance pour tous vos besoins en diagnostic et électronique automobile
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="text-center bg-slate-800/30 backdrop-blur-sm p-8 rounded-2xl border border-slate-700 hover:border-red-600 transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className="flex justify-center mb-6">
                {reason.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4">
                {reason.title}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
